import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import Typography from '@mui/material/Typography';
import StatusContext from '../../../contexts/StatusContext'


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const PasswordChangedDialog = () => {
 

  const {
    showpasswordchangeddialog,
    setShowPasswordChangedDialog,
    changeLanguage,

    setShowLoginDialog,

    
} = React.useContext(StatusContext);

  
  const handleClose = () => {
    setShowPasswordChangedDialog(false);

    setShowLoginDialog(false)
 
  };

  return (
    <React.Fragment>
      
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={showpasswordchangeddialog}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {changeLanguage('login', 'titlelogin')}
        </DialogTitle>
       
        <DialogContent dividers>
          <Typography gutterBottom>
          {changeLanguage('login', 'passwordchanged')}
          </Typography>
          
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            OK
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}